<template>
    <div class="modal fade" tabindex="-1" role="dialog" aria-hidden="true" id="status-modal">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">書籍の属性強制変更</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-group">
                        <label>レーティング</label>
                        <div>
                            <label class="btn btn-light btn-radio" :class="{active: book.rating_id === null}">
                                <input type="radio" v-model="book.rating_id" :value="null" />
                                無し
                            </label>
                            <label v-for="v in ratings" :key="v.id" class="btn btn-light btn-radio" :class="{active: book.rating_id == v.id}">
                                <input type="radio" v-model="book.rating_id" :value="v.id" />
                                {{v.rating_name}}
                            </label>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" id="override-switch" v-model="book.override">
                            <label class="custom-control-label" for="override-switch">ユーザーによるレーティング変更を禁じる</label>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">閉じる</button>
                    <button type="button" class="btn btn-outline-primary" @click="save()">保存 (ctrl + Enter)</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        id: {
            default: null,
        }
    },
    data() {
        return {
            book: {},
            ratings: [],
        }
    },
    methods: {
        load() {
            axios.get("/admin/book/get", {params: {id: this.id}}).then(res => {
                if (res.data.override_at) {
                    res.data.override = 1;
                }
                this.book = res.data;
            }).catch(err => { alert.err(err.response) });
        },
        save() {
            axios.post("/admin/book/save", this.book).then(res => {
                alert.msg(res.data);
                this.$emit("saved");
                $("#status-modal").modal("hide");
            }).catch(err => { alert.err(err.response) });
        },
    },
    mounted() {
        axios.get("/master/ratings").then(res => {
            this.ratings = res.data;
        }).catch(err => {
            alert.err(err.response);
        });
        $("#status-modal").on("show.bs.modal", (e) => {
            this.load();
        });
        $("#status-modal").on("hide.bs.modal", (e) => {
            this.$emit("closed");
        });
    }
}
</script>